/***********************************************
ICEMEDX - Developed By ICEMEDX, Inc.
Copyright 2025 ICEMEDX, Inc.
***********************************************/
import { Injectable } from '@angular/core';
import { IceEntity } from '../core/IceEntity';
import { encounterindex } from '../ehr/encounterindex';

export class encounterstat extends encounterindex {

  public gettablename(): string {
    return "ENCOUNTER_STAT";
  }
}
